import React, { Component } from "react";
import { connect } from "react-redux";

import { Row } from "app/NativeComponents/common";
import { SelectItem } from "app/NativeComponents/snippets";

import { getLimitsForAllPlan, pushSidePanel } from "app/NativeActions";

class LeadStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lead_status: props.lead_status || {},
      deleting: false,
      status_type_options: [
        { label: "No Status Type", value: "" },
        { label: "Lead Generation", value: "lead_generation_status" },
        { label: "Marketing", value: "marketing_status" },
        { label: "Warm Lead", value: "warm_lead_status" },
        { label: "Hot Lead", value: "hot_lead_status" },
        { label: "Acquisitions", value: "acquisition_status" },
        { label: "Dispositions", value: "disposition_status" },
        { label: "Not Interested (Complete)", value: "not_interested_status" },
        { label: "Unqualified (Complete)", value: "unqualified_status" },
        { label: "Unresponsive (Complete)", value: "marketing_complete_status" },
        { label: "Inactive (Complete)", value: "inactive_status" },
        { label: "Won (Complete)", value: "won_status" }
      ],
      loading: false
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.lead_status &&
      this.props.lead_status !== prevProps.lead_status
    ) {
      this.setState({
        lead_status: this.props.lead_status
      });
    }
  }

  renderStatusTypeLabel(lead_status, status_order) {
    switch (lead_status.status_type) {
      default:
        break;
      case "lead_generation_status": return "Lead Generation";
      case "marketing_status": return "Marketing";
      case "warm_lead_status": return "Warm Lead";
      case "hot_lead_status": return "Hot Lead";
      case "acquisition_status": return "Acquisitions";
      case "disposition_status": return "Dispositions";
      case "won_status": return "Won (Complete)";
      case "inactive_status": return "Inactive (Complete)";
      case "marketing_complete_status": return "Unresponsive (Complete)";
      case "not_interested_status": return "Not Interested (Complete)";
      case "unqualified_status": return "Unqualified (Complete)";
      case "return_to_sender_status": return "Return To Sender";
      case "trash_status": return "Trash";
    }
  }

  render() {
    const { lead_status } = this.state;
    const { status_order, source_of_truth } = this.props;
    const limits = getLimitsForAllPlan(source_of_truth);

    return (
      <>
        {!limits.include_custom_statuses ? (
          // Locked → open Contact Support panel
          <SelectItem
            noPress={false}
            select_type={"icon"}
            select_icon={"lock"}
            subtext={this.renderStatusTypeLabel(lead_status, status_order)}
            onPress={() => {
              this.props.pushSidePanel({
                slug: "contact_support_lead_statuses",
                overlay: true
              });
            }}
            renderRight={() => (
              <Row>
                {this.props.wrappedHandle ? this.props.wrappedHandle() : null}
              </Row>
            )}
          >
            {lead_status.title}
          </SelectItem>
        ) : (
          <SelectItem
            noPress={false}
            select_type={"none"}
            subtext={this.renderStatusTypeLabel(lead_status, status_order)}
            onPress={() => {
              this.props.setActiveLeadStatus(lead_status);
            }}
            renderRight={() => (
              <Row>
                {this.props.wrappedHandle ? this.props.wrappedHandle() : null}
              </Row>
            )}
          >
            {lead_status.title}
          </SelectItem>
        )}
      </>
    );
  }
}

export default connect(null, { pushSidePanel })(LeadStatus);
